/**
 * GTM / dataLayer events requested by marketing:
 * - add_to_cart (GA4 ecommerce) on successful cart adds
 * - form_submit for Offerly offer form (#submitOfferButton)
 */
(function () {
  window.dataLayer = window.dataLayer || [];

  var scriptEl =
    document.currentScript ||
    document.querySelector('script[src*="gtm-datalayer-events"][data-currency]');
  var currency =
    (scriptEl && scriptEl.getAttribute('data-currency')) ||
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
    'USD';

  var lastPushKey = '';
  var lastPushAt = 0;

  /**
   * @param {string} key
   * @returns {boolean}
   */
  function shouldPush(key) {
    var now = Date.now();
    if (key === lastPushKey && now - lastPushAt < 1500) return false;
    lastPushKey = key;
    lastPushAt = now;
    return true;
  }

  /**
   * Shopify money values are usually cents (integer or numeric string).
   * @param {unknown} value
   * @returns {number}
   */
  function toDecimalPrice(value) {
    var n = typeof value === 'string' ? parseFloat(value) : Number(value);
    if (!isFinite(n)) return 0;
    // Presentment-style decimals are already major units
    if (n > 0 && n < 1000 && String(value).indexOf('.') !== -1) return Math.round(n * 100) / 100;
    return Math.round(n) / 100;
  }

  /**
   * @param {Record<string, unknown>} item
   * @returns {{ item_id: string, item_name: string, price: number, item_variant: string, quantity: number }}
   */
  function mapCartItem(item) {
    var variantTitle = item.variant_title;
    if (variantTitle === 'Default Title' || variantTitle == null) variantTitle = '';

    var price = toDecimalPrice(
      item.final_price != null
        ? item.final_price
        : item.discounted_price != null
          ? item.discounted_price
          : item.price
    );

    return {
      item_id: String(item.variant_id || item.id || item.product_id || ''),
      item_name: String(item.product_title || item.title || ''),
      price: price,
      item_variant: String(variantTitle || ''),
      quantity: Number(item.quantity) || 1,
    };
  }

  /**
   * @param {unknown} payload
   */
  function pushAddToCart(payload) {
    if (!payload || typeof payload !== 'object') return;
    if (/** @type {{ status?: unknown }} */ (payload).status) return;

    var raw = /** @type {Record<string, unknown>} */ (payload);
    /** @type {Record<string, unknown>[]} */
    var items = [];

    if (Array.isArray(raw.items)) {
      items = raw.items.filter(function (entry) {
        return entry && typeof entry === 'object';
      });
    } else if (raw.variant_id != null || raw.product_id != null || raw.id != null) {
      items = [raw];
    }

    if (!items.length) return;

    var mapped = items.map(mapCartItem);
    var value = mapped.reduce(function (sum, entry) {
      return sum + entry.price * entry.quantity;
    }, 0);
    var dedupeKey = 'atc:' + mapped.map(function (entry) {
      return entry.item_id + ':' + entry.quantity;
    }).join('|');

    if (!shouldPush(dedupeKey)) return;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: Math.round(value * 100) / 100,
        items: mapped,
      },
    });
  }

  /**
   * @param {unknown} product
   * @param {unknown} quantity
   */
  function pushAddToCartFromSearchanise(product, quantity) {
    if (!product || typeof product !== 'object') return;
    var p = /** @type {Record<string, unknown>} */ (product);
    var priceRaw = p.price != null ? p.price : p.final_price;
    var price =
      typeof priceRaw === 'string' && priceRaw.indexOf('.') !== -1
        ? Math.round(parseFloat(priceRaw) * 100) / 100
        : toDecimalPrice(priceRaw);

    var qty = Number(quantity) || 1;
    var itemId = String(p.product_variant_id || p.variant_id || p.id || '');
    if (!itemId) return;
    if (!shouldPush('atc:' + itemId + ':' + qty)) return;

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: currency,
        value: Math.round(price * qty * 100) / 100,
        items: [
          {
            item_id: itemId,
            item_name: String(p.title || p.name || ''),
            price: price,
            item_variant: String(p.variant_title || p.variant || ''),
            quantity: qty,
          },
        ],
      },
    });
  }

  function pushOfferFormSubmit() {
    if (!shouldPush('form:submitOfferButton')) return;

    window.dataLayer.push({
      event: 'form_submit',
      lead_form_id: 'submitOfferButton',
      lead_type: 'Offer Form',
    });
  }

  /**
   * @param {string} url
   * @returns {boolean}
   */
  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/add(\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add/.test(url);
    }
  }

  // --- Add to cart via fetch (/cart/add.js) ---
  if (typeof window.fetch === 'function') {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url =
        typeof input === 'string'
          ? input
          : input && typeof input === 'object' && 'url' in input
            ? String(/** @type {{ url: string }} */ (input).url)
            : '';

      return originalFetch(input, init).then(function (response) {
        if (!isCartAddUrl(url) || !response.ok) return response;

        response
          .clone()
          .json()
          .then(pushAddToCart)
          .catch(function () {
            /* non-JSON cart responses are ignored */
          });

        return response;
      });
    };
  }

  // --- Searchanise quick-add (may not always hit fetch wrapper first) ---
  function bindSearchanise() {
    var sn = window.Searchanise;
    if (!sn || typeof sn.$ !== 'function') return;
    sn.$(document).on('Searchanise.AddToCartSuccess', function (_event, _id, product) {
      pushAddToCartFromSearchanise(product, 1);
    });
  }

  if (window.Searchanise && window.Searchanise.$) {
    bindSearchanise();
  } else {
    document.addEventListener('Searchanise.Loaded', bindSearchanise, { once: true });
  }

  // --- Offerly offer form ---
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      if (target.closest('#submitOfferButton')) {
        pushOfferFormSubmit();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.querySelector('#submitOfferButton') || form.id === 'submitOfferButton') {
        pushOfferFormSubmit();
      }
    },
    true
  );
})();
